

const UseCases = () => {
  const cases = [
    {
      icon: 'ri-calendar-check-line',
      title: 'Günlük Piyasa Takibi',
      description: 'Her gün piyasa açılışında BAGA ile genel durumu kontrol edin. Hangi hisselerin hareketli olduğunu, hangi kararların üretildiğini anında görün.',
      user: 'Ahmet Y.',
      role: 'Bireysel Yatırımcı',
    },
    {
      icon: 'ri-eye-line',
      title: 'Hızlı Genel Görünüm',
      description: 'Zamanınız kısıtlı mı? BAGA ile tek bir ekranda yüzlerce hissenin durumunu görüntüleyin. Detaylı analiz yapmadan önce piyasanın nabzını tutun.',
      user: 'Zeynep K.',
      role: 'Aktif Trader',
    },
    {
      icon: 'ri-pulse-line',
      title: 'Karar Öncesi Piyasa Nabzı',
      description: 'Yatırım kararı vermeden önce BAGA kararlarını kontrol edin. Algoritmanın ürettiği analiz sonuçları, karar sürecinize değerli bir girdi sağlar.',
      user: 'Mehmet S.',
      role: 'Portföy Yöneticisi',
    },
  ];

  return (
    <section className="py-16 sm:py-24 lg:py-32 bg-dark relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-emerald/5 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-10 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-beige-light mb-4 sm:mb-6">
            Kullanım Senaryoları
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-beige/70 max-w-2xl mx-auto px-4">
            BAGA, farklı yatırımcı profillerine uygun çözümler sunar
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {cases.map((item, index) => (
            <div
              key={index}
              className={`bg-dark-card border-t-4 border-emerald rounded-xl sm:rounded-2xl p-6 sm:p-8 lg:p-10 hover:shadow-2xl hover:shadow-emerald/10 transition-all hover:-translate-y-2 ${
                index === 2 ? 'sm:col-span-2 lg:col-span-1' : ''
              }`}
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-emerald/10 rounded-xl sm:rounded-2xl flex items-center justify-center mb-4 sm:mb-6">
                <i className={`${item.icon} text-emerald text-xl sm:text-2xl lg:text-3xl`}></i>
              </div>
              
              <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-beige-light mb-3 sm:mb-4">
                {item.title}
              </h3>
              
              <p className="text-sm sm:text-base text-beige/70 leading-relaxed mb-6 sm:mb-8">
                {item.description}
              </p>

              <div className="flex items-center gap-3 pt-4 sm:pt-6 border-t border-gray-800">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-emerald to-emerald-light rounded-full flex items-center justify-center text-beige-light font-bold text-xs sm:text-sm">
                  {item.user.charAt(0)}
                </div>
                <div>
                  <div className="text-beige-light font-semibold text-xs sm:text-sm">{item.user}</div>
                  <div className="text-beige/50 text-xs">{item.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCases;
